<h1 mat-dialog-title tabindex="-1" cdkFocusInitial align="center">Terms &amp; Conditions</h1>
<div mat-dialog-content>
  <p [innerHTML]="data ?? 'No Data'"></p>
</div>
<div mat-dialog-actions align="center">
  <button mat-flat-button color="warn" mat-dialog-close>Ok</button>
</div>
